var _ = require('underscore');
var ko = require('knockout');

var SetsUtil = require('./util/sets');
var viewModelBase = require('../tk/view_model/base.js');

// A FilterGroup view model coordinates one or more filters. It does two things:
// enforces radio or checkbox behavior of its filters and calculates the full
// intersection of opaque ids represented by all enabled filters.
//
// namespace  - String namespace of the group.
// isCheckbox - Boolean true if more than one filter may be enabled.
//              at a time.
//
var FilterGroup = viewModelBase.create({
  init: function(namespace, isCheckbox) {
    this.namespace = namespace;
    this.isCheckbox = isCheckbox;

    // The Filters in the group.
    this.filters = ko.observableArray();

    // Maintain the currently enabled filters.
    this.enabledFilters = ko.computed({
      read: this._enabledFilters_read,
      write: this._enabledFilters_write,
      owner: this
    });

    // Get the set of opaque ids for the entire group.
    this.currentOpaqueIds = ko.computed(this._currentOpaqueIds_read, this);
  },

  // Public: Add a filter to the group.
  //
  // filter - Filter to add.
  //
  // Returns nothing.
  addFilter: function(filter) {
    this.filters.push(filter);
    // Disable other filters when one is enabled unless this is a isCheckbox group.
    if (!this.isCheckbox) {
      filter.isEnabled.subscribe(function(newEnabled) {
        if (newEnabled) {
          _.each(this.filters(), function(f) {
            if (f != filter) f.isEnabled(false);
          });
        }
      }.bind(this));
    }
  },

  // Read enabledFilters.
  _enabledFilters_read: function() {
    return _.select(this.filters(), function(f) { return f.isEnabled(); });
  },

  // Write enabledFilters.
  _enabledFilters_write: function(filters) {
    var filters = this.isCheckbox ? filters : filters.slice(0, 1);
    _.each(this.filters(), function(f) {
      var included = _.include(filters, f);
      f.isEnabled(included);
    });
  },

  // Read currentOpaqueIds.
  //
  // Returns an Array of IDs or null if there are no active enabled filters.
  _currentOpaqueIds_read: function() {
    var sets = _.map(this.enabledFilters(), function(f) { return f.opaqueIds; });
    if (sets.length) {
      return SetsUtil.intersectSets(sets);
    } else {
      return null;
    }
  }
});

module.exports = FilterGroup;
